import { FinanceCostsTable } from "components/Tables/FinanceCostsTable/FinanceCostsTable.tsx";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { createTenantFileRoute } from "utils/createTenantFileRoute";
import { getFinanceHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/finance/_layout/cost/")({
    component: FinanceCostsPage,
    staticData: {
        permissions: [],
        //permissions: [PermissionEnum.FinanceCostView],
        showInSideMenu: false,
        label: "pages.finance.cost.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.finance.cost.title"),
        };
    },
});

function FinanceCostsPage() {
    return (
        <TenantPage headerNavigationItems={getFinanceHeaderItems}>
            <FinanceCostsTable />
        </TenantPage>
    );
}
